/* ==========================================================================
   Automatische Geschenke ab Bestellwert.
   Ersetzt die Geschenk-App: statt 19 Dateien eine.

   Arbeitsteilung:
     - Diese Datei legt den Artikel in den Warenkorb und nimmt ihn wieder
       heraus, wenn der Wert unter die Schwelle fällt.
     - Den Preis auf 0 € setzt ein automatischer Shopify-Rabatt, NICHT
       dieses Skript. Serverseitig, im Checkout verbindlich, von hier aus
       nicht manipulierbar.

   Geschenkpositionen tragen die Eigenschaft _kz_gift. Der Unterstrich
   sorgt dafür, dass Shopify sie nicht im Warenkorb anzeigt.
   ========================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('kz-gift-config');
  if (!cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG.aktiv || !CFG.stufen || !CFG.stufen.length) return;

  var laeuft = false;
  var warteschlange = false;

  /* Letzter bekannter Warenkorb. Damit laesst sich beim Hinzufuegen
     vorhersagen, ob die Schwelle fallen wird - und das Geschenk kann in
     denselben Request wie das Produkt. */
  var letzterKorb = null;

  /* Geschenke, die in einem noch offenen /cart/add-Request mitfahren.
     Ohne diesen Merker mischt ein zweiter Klick dasselbe Geschenk ein
     zweites Mal bei - Shopify fasst beide zu einer Zeile mit Menge 2
     zusammen. Genau so entstand Bestellung #562888. */
  var injiziert = {};

  function injizierungMerken(id) {
    injiziert[id] = true;
    /* Notbremse: bleibt die Antwort aus, waere das Geschenk sonst fuer
       den Rest der Sitzung gesperrt. */
    setTimeout(function () { delete injiziert[id]; }, 8000);
  }

  /* Das echte fetch festhalten, bevor wir es weiter unten ersetzen.
     Eigene Anfragen dürfen nicht in den eigenen Abgleich zurücklaufen -
     sonst löst jede eigene Änderung einen weiteren Durchlauf aus. */
  var echtesFetch = window.fetch.bind(window);

  function hole(url, opt) {
    return echtesFetch(url, Object.assign({ headers: { 'Accept': 'application/json' } }, opt || {}));
  }

  function istGeschenk(item) {
    return !!(item.properties && item.properties._kz_gift);
  }

  /* Basis für die Schwelle: nur Artikel der Marke, Geschenke zählen nicht mit. */
  function basisWert(cart) {
    var summe = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (istGeschenk(it)) continue;
      if (CFG.nurMarke && it.vendor !== CFG.marke) continue;
      summe += it.final_line_price;
    }
    return summe;
  }

  function geschenkZeile(cart, stufenId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].properties && cart.items[i].properties._kz_gift === stufenId) {
        return cart.items[i];
      }
    }
    return null;
  }

  function variantImKorb(cart, variante) {
    for (var i = 0; i < cart.items.length; i++) {
      if (Number(cart.items[i].variant_id) === Number(variante)) return true;
    }
    return false;
  }

  /* Alle Varianten, die ueberhaupt Geschenke sein duerfen. */
  function geschenkVarianten() {
    return CFG.stufen.map(function (s) { return Number(s.variante); });
  }

  /* Geschenkartikel, die jemand von Hand hinzugefuegt hat: ohne unsere
     Markierung, also ohne Berechtigung. Die Varianten-IDs stehen im
     Quelltext - ohne diese Pruefung koennte sich jeder beliebig viele
     Gratisartikel in den Warenkorb legen. */
  function unberechtigteGeschenke(cart) {
    var erlaubt = geschenkVarianten();
    var treffer = [];
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (erlaubt.indexOf(Number(it.variant_id)) === -1) continue;
      if (!istGeschenk(it)) treffer.push(it);
    }
    return treffer;
  }

  /* ------------------------------------------------------------------
     Welche Abschnitte muss der Server neu rendern?

     Die IDs stehen nicht fest - Vogal haengt die Vorlagen-ID an, etwa
     template--26511260221705__main. Genau hier lag der zweite Fehler:
     das Theme laedt in onCartUpdate() hart "main-cart-items" nach, eine
     Section, die es in diesem Theme nicht gibt. Der Austausch lief ins
     Leere, die Geschenkzeile erschien auf der Warenkorbseite erst nach
     einem Neuladen. Darum zur Laufzeit aus dem DOM lesen statt raten.
     ------------------------------------------------------------------ */
  /* Je Eintrag: Ankerelement, Ersatzname, Elemente die ersetzt werden.

     Der Ersatzname ist nötig, weil der Drawer hier als Snippet direkt in
     theme.liquid steckt und deshalb gar keinen shopify-section-Wrapper
     hat - gesucht würde nichts, angefordert nichts, der Drawer blieb
     leer. sections/cart-drawer.liquid existiert aber und rendert genau
     dieses Snippet, der Name ist für die Section-API also gültig. */
  var ZIELE = [
    ['cart-items', 'main-cart', ['cart-items', '.cart__footer', '#main-cart-footer']],
    ['cart-drawer', 'cart-drawer', ['cart-drawer-items', '.cart-drawer__footer']]
  ];

  function abschnittsNamen() {
    var namen = [];
    ZIELE.forEach(function (eintrag) {
      var el = document.querySelector(eintrag[0]);
      if (!el) return;
      var wrap = el.closest ? el.closest('[id^="shopify-section-"]') : null;
      var name = wrap ? wrap.id.replace('shopify-section-', '') : eintrag[1];
      if (name && namen.indexOf(name) === -1) namen.push(name);
    });
    return namen;
  }

  /* Fertiges HTML aus der Antwort einsetzen. innerHTML, nicht replaceWith:
     die Custom Elements (cart-items, cart-drawer-items) bleiben dann als
     Instanz bestehen, waehrend die Zeilen darin frisch sind - damit sind
     auch die Zeilennummern wieder korrekt, an denen sich vorher
     "Parameter line ist ungueltig" aufgehaengt hat. */
  function abschnitteEinsetzen(abschnitte) {
    if (!abschnitte) return false;
    var etwas = false;
    Object.keys(abschnitte).forEach(function (name) {
      var roh = abschnitte[name];
      if (!roh || typeof roh !== 'string') return;
      var neu = new DOMParser().parseFromString(roh, 'text/html');
      ZIELE.forEach(function (eintrag) {
        eintrag[2].forEach(function (sel) {
          var ziel = document.querySelector(sel);
          var quelle = neu.querySelector(sel);
          if (!ziel || !quelle) return;
          ziel.innerHTML = quelle.innerHTML;
          /* Klassen mituebernehmen: bei leerem Warenkorb steht "hide" auf
             diesen Containern, und ein reiner Inhaltstausch laesst sie
             unsichtbar. */
          if (quelle.getAttribute('class') !== null) {
            ziel.setAttribute('class', quelle.getAttribute('class'));
          }
          etwas = true;
        });
      });
    });
    if (etwas) geschenkeNachUnten();
    return etwas;
  }

  /* Das Theme rendert nach seiner eigenen Anfrage ebenfalls neu - mit HTML
     von vor dem Geschenk. Landet das nach uns, waere die Zeile wieder weg.
     Einmal nachfassen, aus dem schon vorhandenen HTML, ohne neue Anfrage. */
  function nachfassen(abschnitte) {
    setTimeout(function () {
      if (!document.querySelector('.kz-geschenk')) abschnitteEinsetzen(abschnitte);
    }, 400);
  }

  function abgleichen(vorab) {
    if (laeuft) { warteschlange = true; return Promise.resolve(); }
    laeuft = true;

    var namen = abschnittsNamen();
    var seite = window.location.pathname;
    var abschnitte = null;
    var delta = 0;
    var willGeschenk = false;

    function merken(antwort) {
      if (antwort && antwort.sections) abschnitte = antwort.sections;
      return antwort;
    }

    function mengeSetzen(key, menge) {
      var koerper = { id: key, quantity: menge };
      if (namen.length) { koerper.sections = namen; koerper.sections_url = seite; }
      return hole('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(koerper)
      }).then(function (r) { return r.json(); }).then(merken).catch(function () {});
    }

    function geschenkDazu(stufe) {
      var fd = new FormData();
      fd.append('id', stufe.variante);
      fd.append('quantity', 1);
      fd.append('properties[_kz_gift]', stufe.id);
      if (namen.length) {
        fd.append('sections', namen.join(','));
        fd.append('sections_url', seite);
      }
      return hole('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); }).then(merken).catch(function () {});
    }

    /* Den Warenkorb nicht neu abfragen, wenn die abgefangene Antwort ihn
       schon enthaelt. Das war vorher ein kompletter Roundtrip fuer Daten,
       die bereits vorlagen. */
    var start = (vorab && vorab.items)
      ? Promise.resolve(vorab)
      : hole('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });

    return start
      .then(function (cart) {
        letzterKorb = cart;
        var basis = basisWert(cart);
        var kette = Promise.resolve();
        var anzahl = cart.item_count;
        var etwasGeaendert = false;

        /* Zuerst aufraeumen: unmarkierte Geschenkartikel fliegen raus. */
        unberechtigteGeschenke(cart).forEach(function (zeile) {
          etwasGeaendert = true;
          delta -= zeile.quantity;
          kette = kette.then(function () { return mengeSetzen(zeile.key, 0); });
        });

        CFG.stufen.forEach(function (stufe) {
          var vorhanden = geschenkZeile(cart, stufe.id);
          var sollte = basis >= stufe.schwelle;
          if (sollte) willGeschenk = true;

          if (sollte && !vorhanden) {
            etwasGeaendert = true;
            delta += 1;
            kette = kette.then(function () { return geschenkDazu(stufe); });
          } else if (!sollte && vorhanden) {
            etwasGeaendert = true;
            delta -= vorhanden.quantity;
            kette = kette.then(function () { return mengeSetzen(vorhanden.key, 0); });
          } else if (sollte && vorhanden && vorhanden.quantity !== 1) {
            /* Jemand hat die Menge hochgesetzt - zurueck auf eins. */
            etwasGeaendert = true;
            delta += 1 - vorhanden.quantity;
            kette = kette.then(function () { return mengeSetzen(vorhanden.key, 1); });
          }
        });

        return kette.then(function () {
          return { geaendert: etwasGeaendert, anzahl: anzahl + delta };
        });
      })
      .then(function (ergebnis) {
        laeuft = false;
        injiziert = {};
        if (warteschlange) { warteschlange = false; return abgleichen(); }
        geschenkeNachUnten();
        if (!ergebnis.geaendert) return ergebnis;

        document.dispatchEvent(new CustomEvent('kz:geschenke-aktualisiert'));
        zaehlerAktualisieren(ergebnis.anzahl);

        /* Das HTML kam in derselben Antwort mit - kein weiterer Roundtrip. */
        if (abschnitteEinsetzen(abschnitte)) {
          if (willGeschenk) nachfassen(abschnitte);
        } else {
          themaNeuZeichnen();
        }
        return ergebnis;
      })
      .catch(function () { laeuft = false; injiziert = {}; });
  }

  /* Notnagel, falls die Antwort kein HTML mitgebracht hat: Abschnitte
     einzeln nachladen - diesmal unter den IDs, die es wirklich gibt. */
  function themaNeuZeichnen() {
    var namen = abschnittsNamen();
    if (!namen.length) return;
    hole('/?sections=' + encodeURIComponent(namen.join(',')))
      .then(function (r) { return r.json(); })
      .then(function (daten) { abschnitteEinsetzen(daten); })
      .catch(function () {});
  }

  /* Geschenkzeilen in der Tabelle der Warenkorbseite nach unten holen.
     Shopify haengt neue Artikel vorne an; im Drawer loest das die
     Flex-Reihenfolge, in einer Tabelle wuerde Flexbox das Layout
     zerlegen - also hier von Hand umhaengen. */
  function geschenkeNachUnten() {
    document.querySelectorAll('table.cart-items tbody').forEach(function (tbody) {
      tbody.querySelectorAll(':scope > tr.kz-geschenk').forEach(function (tr) {
        tbody.appendChild(tr);
      });
    });
  }

  /* Die Zahl kennen wir schon - die fruehere Version hat dafuer /cart.js
     abgefragt, also einen Roundtrip fuer eine Zahl. */
  function zaehlerAktualisieren(anzahl) {
    if (typeof anzahl !== 'number' || anzahl < 0) return;
    document.querySelectorAll('.cartCount').forEach(function (el) {
      el.textContent = anzahl;
    });
    /* Die Ueberschrift des Drawers ("Einkaufswagen (5)") steht ausserhalb
       von cart-drawer-items und wird vom Abschnittstausch nicht erfasst.
       Ohne das bleibt dort die alte Zahl stehen. */
    document.querySelectorAll('[data-cart-render="item_count"]').forEach(function (el) {
      el.textContent = anzahl;
    });
  }

  /* ------------------------------------------------------------------
     Das Geschenk in denselben Request legen wie das Produkt.

     Sonst sind es zwei Schreibvorgaenge hintereinander: erst legt das
     Theme das Produkt rein (~400 ms), dann wir das Geschenk (~550 ms).
     Das Geschenk erschien dadurch rund eine Sekunde nach dem Klick -
     genau der Unterschied zur alten App. Shopify nimmt bei /cart/add.js
     aber mehrere Artikel auf einmal, gemessen 564 ms fuer beides.

     Serverseitig geht das uebrigens nicht: die Cart-Transform-API kennt
     nur expand, merge und update - keine neue Zeile. Auch eine eigene
     App muesste es so machen.
     ------------------------------------------------------------------ */

  /* Preis der Variante in Cent. Shopify legt die Daten selbst auf jede
     Produktseite, unabhaengig vom Theme. 0 bedeutet: zaehlt nicht zur
     Schwelle (andere Marke). null bedeutet: unbekannt, dann nicht raten. */
  function variantenPreis(vid) {
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (!m || !m.product || !m.product.variants) return null;
      if (CFG.nurMarke && m.product.vendor !== CFG.marke) return 0;
      for (var i = 0; i < m.product.variants.length; i++) {
        if (Number(m.product.variants[i].id) === Number(vid)) {
          return Number(m.product.variants[i].price);
        }
      }
    } catch (e) {}
    return null;
  }

  /* Baut aus dem Original-FormData eines nur bei Bedarf einen gemeinsamen
     Request. Im Zweifel null - dann geht der Originalrequest unveraendert
     durch. Der Warenkorb des Kunden ist wichtiger als die Millisekunden. */
  function gemeinsamerKoerper(fd) {
    if (!letzterKorb || !fd || typeof fd.get !== 'function') return null;
    if (fd.has('items[0][id]') || fd.has('items')) return null;

    var vid = fd.get('id');
    if (!vid) return null;
    var menge = Number(fd.get('quantity') || 1);
    if (!(menge > 0)) return null;

    var preis = variantenPreis(vid);
    if (preis === null) return null;

    /* Was gerade hinzukommt, ist noch nicht im Warenkorb - also dazurechnen. */
    /* Laeuft schon ein Abgleich, legt der das Geschenk selbst hinein.
       Dann hier nichts beimischen - sonst sind zwei Schreibvorgaenge
       fuer dasselbe Geschenk unterwegs. */
    if (laeuft) return null;

    var basis = basisWert(letzterKorb) + preis * menge;
    var fehlende = [];
    CFG.stufen.forEach(function (stufe) {
      if (basis < stufe.schwelle) return;
      if (geschenkZeile(letzterKorb, stufe.id)) return;
      /* Auch eine unmarkierte Zeile derselben Variante zaehlt - sonst
         legen wir ein zweites Exemplar daneben. */
      if (variantImKorb(letzterKorb, stufe.variante)) return;
      if (injiziert[stufe.id]) return;
      fehlende.push(stufe);
    });
    if (!fehlende.length) return null;

    var neu = new FormData();
    neu.append('items[0][id]', String(vid));
    neu.append('items[0][quantity]', String(menge));

    /* Eigenschaften der Originalzeile mitnehmen, falls das Theme welche
       setzt - sonst gingen sie beim Umbau verloren. */
    fd.forEach(function (wert, schluessel) {
      var treffer = schluessel.match(/^properties\[(.+)\]$/);
      if (treffer) neu.append('items[0][properties][' + treffer[1] + ']', wert);
    });

    fehlende.forEach(function (stufe, i) {
      var n = i + 1;
      injizierungMerken(stufe.id);
      neu.append('items[' + n + '][id]', String(stufe.variante));
      neu.append('items[' + n + '][quantity]', '1');
      neu.append('items[' + n + '][properties][_kz_gift]', stufe.id);
    });

    /* Das Theme braucht sein gerendertes HTML - unveraendert weitergeben. */
    ['sections', 'sections_url', 'form_type', 'utf8'].forEach(function (k) {
      if (fd.has(k)) neu.append(k, fd.get(k));
    });
    return neu;
  }

  /* Jede fremde Warenkorb-Aenderung anstossen - egal ob Theme oder App. */
  var cartPfad = /\/cart\/(add|change|update|clear)(\.js)?/;
  var addPfad = /\/cart\/add(\.js)?/;

  function istWarenkorb(d) {
    return !!(d && d.items && typeof d.item_count === 'number');
  }

  function nachAntwort(p) {
    p.then(function (r) {
      /* Die Antwort enthaelt den Warenkorb schon - klonen und direkt
         verwenden, statt /cart.js noch einmal zu fragen. */
      var kopie = null;
      try { kopie = r.clone(); } catch (e) {}
      if (!kopie) { abgleichen(); return; }
      kopie.json()
        .then(function (d) { abgleichen(istWarenkorb(d) ? d : null); })
        .catch(function () { abgleichen(); });
    }).catch(function () {});
    return p;
  }

  window.fetch = function () {
    var url = arguments[0];
    var pfad = typeof url === 'string' ? url : (url && url.url) || '';

    /* Hinzufuegen: wenn dadurch eine Schwelle fallen wird, das Geschenk
       mit in denselben Request. Nur dann - in jedem anderen Fall laeuft
       der Originalrequest unangetastet durch. */
    if (addPfad.test(pfad)) {
      var init = arguments[1];
      var koerper = init && init.body;
      var zusammen = null;
      if (koerper && typeof FormData !== 'undefined' && koerper instanceof FormData) {
        try { zusammen = gemeinsamerKoerper(koerper); } catch (e) { zusammen = null; }
      }
      if (zusammen) {
        var ich = this;
        var umgebaut = {};
        Object.keys(init).forEach(function (k) { umgebaut[k] = init[k]; });
        umgebaut.body = zusammen;
        return echtesFetch.call(ich, url, umgebaut).then(function (r) {
          /* Geht der Umbau schief, sofort den Originalrequest nachschieben.
             Der Kunde soll sein Produkt auf jeden Fall im Warenkorb haben. */
          if (!r.ok) return nachAntwort(echtesFetch.call(ich, url, init));
          /* Produkt und Geschenk sind drin, das Theme zeichnet beides.
             Der Abgleich danach dient nur noch dem Gegenpruefen. */
          return nachAntwort(Promise.resolve(r));
        }, function () {
          return nachAntwort(echtesFetch.call(ich, url, init));
        });
      }
    }

    var p = echtesFetch.apply(this, arguments);
    if (cartPfad.test(pfad)) nachAntwort(p);
    return p;
  };

  var echtesOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    if (cartPfad.test(url || '')) {
      this.addEventListener('load', function () {
        var d = null;
        try { d = JSON.parse(this.responseText); } catch (e) {}
        abgleichen(istWarenkorb(d) ? d : null);
      });
    }
    return echtesOpen.apply(this, arguments);
  };

  /* ------------------------------------------------------------------
     Letzter Abgleich direkt vor der Kasse.

     Alles davor haengt daran, dass jede Warenkorb-Aenderung auch in
     diesem Tab durchgelaufen ist. Tut sie das nicht - zweiter Tab,
     Zurueck-Taste, abgebrochener Request -, kann der Warenkorb von der
     Schwelle abgedriftet sein, und das Geschenk faehrt mit, obwohl der
     Warenwert darunter liegt.

     Darum vor dem Absprung noch einmal abgleichen. Haengt der Abgleich,
     geht es nach 2,5 s trotzdem weiter: der Kunde soll nie vor einem
     toten Knopf stehen.
     ------------------------------------------------------------------ */
  var kasseFrei = false;

  function kasseAbsichern() {
    document.addEventListener('click', function (e) {
      if (kasseFrei) return;
      var ziel = e.target;
      var knopf = ziel && ziel.closest ? ziel.closest('.cartCheckout') : null;
      if (!knopf || knopf.disabled) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      var erledigt = false;
      var uhr = setTimeout(function () { durchlassen(); }, 2500);

      function durchlassen() {
        if (erledigt) return;
        erledigt = true;
        clearTimeout(uhr);
        kasseFrei = true;
        /* Nach einem Neuaufbau ist der angeklickte Knopf aus dem DOM
           verschwunden - dann den frischen nehmen. */
        var frisch = document.querySelector('.cartCheckout:not([disabled])');
        (frisch || knopf).click();
      }

      function anhalten() {
        if (erledigt) return;
        erledigt = true;
        clearTimeout(uhr);
      }

      abgleichen().then(function (erg) {
        /* Wurde etwas korrigiert, sind Warenkorb und AGB-Haken neu
           gezeichnet. Dann nicht durchklicken: der Kunde soll die
           Aenderung sehen und selbst erneut auf "Zur Kasse" gehen. */
        if (erg && erg.geaendert) { anhalten(); return; }
        durchlassen();
      }, durchlassen);
    }, true);
  }

  kasseAbsichern();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { abgleichen(); });
  } else {
    abgleichen();
  }
})();
